<template>
    <v-dialog v-model="show" max-width="500px">
        <v-card>
            <v-card color="#FFD375" class="elevation-12">
                <v-toolbar color="#FFA500">
                    <v-toolbar-title>{{title}}</v-toolbar-title>
                </v-toolbar>

                <v-card color="#FFD375" flat class="elevation-12">
                    <v-toolbar class="mt-1" color="#FFA500" flat>
                        <v-toolbar-title flat>Survey</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn color="#FFA500" @click="chooseSurvey()" data-cy="joinSubmitBtn"><v-icon>account_tree</v-icon></v-btn>
                    </v-toolbar>
                    <v-container :key="this.$store.state.updatecount">
                        <span v-for="surveychip in selectedsurveys" :key="surveychip.ID">
                            <v-chip class="ma-1" @click="chipSurveyClick()">{{surveychip.Name}}</v-chip>
                        </span>
                    </v-container>
                </v-card>

                <v-card color="#FFD375" flat class="elevation-12">
                    <v-toolbar class="mt-1" color="#FFA500" flat>
                        <v-toolbar-title flat>Contacts</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn color="#FFA500" @click="chooseContact()" data-cy="joinSubmitBtn"><v-icon flat>account_tree</v-icon></v-btn>
                    </v-toolbar>
                    <v-container :key="this.$store.state.updatecount">
                        <span v-for="contactchip in selectedcontacts" :key="contactchip.ID">
                            <v-chip class="ma-1" @click="chipContactClick(contactchip)">{{contactchip.Name}}</v-chip>
                        </span>
                    </v-container>
                </v-card>

                <v-card color="#FFD375" flat class="elevation-12">
                    <v-toolbar class="mt-1" color="#FFA500" flat>
                        <v-toolbar-title flat>Groups</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn color="#FFA500" @click="chooseGroup()" data-cy="joinSubmitBtn"><v-icon flat>account_tree</v-icon></v-btn>
                    </v-toolbar>
                    <v-container :key="this.$store.state.updatecount">
                        <span v-for="groupchip in selectedgroups" :key="groupchip.ID">
                            <v-chip class="ma-1" @click="chipGroupClick(groupchip)">{{groupchip.Name}}</v-chip>
                        </span>
                    </v-container>
                </v-card>

                <v-card-actions>
                    <v-btn color="#FFA500" @click="cancel" data-cy="joinSubmitBtn">CANCEL</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="#FFA500" :disabled="!buttonchanged" @click="submit" data-cy="joinSubmitBtn">CONFIRM</v-btn>
                </v-card-actions>
            </v-card>

            <StringsListPopup v-bind:listdata=listdata v-model="showStringsListPopup" />

        </v-card>
    </v-dialog>
</template>

<script>

    import StringsListPopup from '@/views/Manage/StringsListPopup';

export default {
      props: {
          value: Boolean,
          selectedshare:Object
            },
       components: {
           StringsListPopup,
       },
      data() {
          return {
              changed: false,
              buttonchanged:true,
              fromlist: false,
              confirmclicked: false,
              listdata:null,
              selectedsurveys: [],
              selectedcontacts: [],
              selectedgroups: [],
              originalselectedsurveys: [],
              originalselectedcontacts: [],
              originalselectedgroups: [],
              showStringsListPopup: false
          };
      },
      computed: {
        show: {
          get () {
            this.initialiseData();
            return this.value
          },
          set(value) {
              if (this.confirmclicked) {

              }
              else {

              }
              this.changed = false;
              this.$emit('input', value)
          }
        },
          title() {
              if (!this.selctedshare)
                return 'Share';
              return 'Share   ' + this.selectedshare.Name;
        }

      },
    methods: {
        copyDataToGlobal() {
            if (this.fromlist)
                return;
            this.$store.state.sharepopupdata = {};
            this.$store.state.sharepopupdata.Survey = this.selectedshare.Survey;
            this.$store.state.sharepopupdata.Contacts = this.selectedshare.Contacts;
            this.$store.state.sharepopupdata.Groups = this.selectedshare.Groups;
        },
        initialiseData() {
            this.selectedsurveys = [];
            this.selectedcontacts = [];
            this.selectedgroups = [];
            this.originalselectedsurveys = [];
            this.originalselectedcontacts = [];
            this.originalselectedgroups = [];
            if ((this.selectedshare) && (!this.changed)) {
                this.copyDataToGlobal();
                if (this.selectedshare.Survey) {
                    var survey = this.findMySurvey(this.selectedshare.Survey);
                    if (survey != null) {
                        this.selectedsurveys.push({ Name: survey.Name, ID: survey.ID });
                        this.originalselectedsurveys.push(survey);
                    }
                }

                if (this.selectedshare.Contacts)
                    this.selectedshare.Contacts.forEach(id => {
                        var contact = this.findMyContact(id);
                        if (contact != null) {
                            this.selectedcontacts.push({ Name: contact.Name, ID: contact.ID });
                            this.originalselectedcontacts.push(contact);
                        }
                    });

                if (this.selectedshare.Groups)
                    this.selectedshare.Groups.forEach(id => {
                        var group = this.findMyGroup(id);
                        if (group!=null) {
                            this.selectedgroups.push({ Name: group.Name, ID: group.ID });
                            this.originalselectedgroups.push(group);
                        }
                    });

                this.selectedcontacts.sort((a, b) => a["Name"] < b["Name"] ? -1 : 1);
                this.selectedgroups.sort((a, b) => a["Name"] < b["Name"] ? -1 : 1);
            }
      },
      chipSurveyClick(chip) {
          const index = this.selectedsurveys.indexOf(chip);
          this.selectedsurveys.splice(index, 1);
          this.checkButton();
      },
      chipContactClick(chip) {
          const index = this.selectedcontacts.indexOf(chip);
          this.selectedcontacts.splice(index, 1);
          this.checkButton();
      },
      chipGroupClick(chip) {
          const index = this.selectedgroups.indexOf(chip);
          this.selectedgroups.splice(index, 1);
          this.checkButton();
      },
      checkButton() {
          this.buttonchanged = true;
      },
      findMySurvey(id) {
          var found = null;
          this.$store.state.surveys.forEach(survey => {
              if (survey.ID === id)
                  found = survey;
          });
          return found;
      },
      findMyContact(id) {
          var found = null;
          this.$store.state.contacts.forEach(contact => {
              if (contact.ID === id)
                  found = contact;
          });
          return found;
      },
      findMyGroup(id) {
        var found = null;
        this.$store.state.groups.forEach(group => {
            if (group.ID === id)
                found = group;
        });
        return found;
      },
      findMyShare(id) {
        var found = null;
        this.$store.state.shares.forEach(share => {
            if (share.ID === id)
                found = share;
        });
        return found;
      },
      chooseSurvey() {
          this.$store.state.sharepopup = this;
          this.listdata = {possible: this.$store.state.surveys, selected: [this.selectedshare.Survey], title: "Survey for " + this.selectedshare.Name, output: this.selectedshare, type:"share.survey"};
          this.showStringsListPopup = true;
          this.show = false;
      },
      chooseContact() {
          this.$store.state.sharepopup = this;
          this.listdata = { possible: this.$store.state.contacts, selected: this.selectedshare.Contacts, title: "Contacts for " + this.selectedshare.Name, output: this.selectedshare, type: "share.contacts"};
          this.showStringsListPopup = true;
          this.show = false;
      },
      chooseGroup() {
          this.$store.state.sharepopup = this;
          this.listdata = { possible: this.$store.state.groups, selected: this.selectedshare.Groups, title: "Groups for " + this.selectedshare.Name, output: this.selectedshare, type: "share.groups"};
          this.showStringsListPopup = true;
          this.show = false;
      },
        cancel() {
            var share = this.findMyShare(this.$store.state.selectedshare.ID);
            if (share != null) {
                share.Survey = this.$store.state.sharepopupdata.Survey;
                share.Contacts = this.$store.state.sharepopupdata.Contacts;
                share.Groups = this.$store.state.sharepopupdata.Groups;
            }
            this.show = false;
      },
        submit() {
            if (this.selectedsurveys.length == 0) {
                this.selectedshare.Survey = null;
            }
            else { 
                this.selectedshare.Survey = this.selectedsurveys[0].ID;
                }

            this.selectedshare.Contacts = [];
            this.selectedcontacts.forEach(itm => { this.selectedshare.Contacts.push(itm.ID); });
            this.selectedshare.Groups = [];
            this.selectedgroups.forEach(itm => { this.selectedshare.Groups.push(itm.ID); });
            this.$store.dispatch('setShare', this.selectedshare);
            this.confirmclicked = true;
            this.show = false;
        }
  }
}
</script>
